export enum StepKey {
  FIRST_STEP_0 = '0-init',
  FIRST_STEP_1 = '1-model',
  FIRST_STEP_2 = '2-vehicle',
  FIRST_STEP_3 = '3-owner',
  SECOND_STEP = 'offers',
  THIRD_STEP = 'payment'
}
